const { errors } = require('@transfeeradev/api-enums');
class DictEntryDivergentDocError extends Error {
  constructor() {
    super(errors.ptBr.codes.receiver_tax_id_divergent.message);
    this.code = errors.ptBr.codes.receiver_tax_id_divergent.code;
    Error.captureStackTrace(this, DictEntryDivergentDocError);
  }
}

module.exports = DictEntryDivergentDocError;
